import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TrustedBy from "./components/Trustedby";
import GoogleWorkspaceAccess from "./components/WorkspaceAccess";
import HowItWorks from "./components/HowItWorks";
import PricingSection from "./components/Pricing";
import Line from "./components/EndLineComp";
import Testimonials from "./components/Testimonials";
import FAQSection from "./components/FAQ";
import CTA from "./components/CTA";
import FeatureNav from "./components/Features";
import Footer from "./components/Footer";

const App = () => {
  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={
            <div className="geist">
              <div className="bg-gradient-to-b from-[#dcefff] to-white">
                <Header />
                <Hero />
              </div>
              <TrustedBy />
              <GoogleWorkspaceAccess />
              <HowItWorks />
              <Line />
              <PricingSection />
              <Line />
              <Testimonials />
              <Line />
              <FAQSection />
              <CTA />
              <FeatureNav />
              <Footer />
            </div>
          }
        />
      </Routes>
    </Router>
  );
};

export default App;
